module.exports = __webpack_public_path__ + "static/buildup_img3-74f45e2ed4d593d5a89ffab5df66c3a1.png";